import antdEn from 'antd/locale/en_US'
import enMessages from '@vacationtracker/shared/i18n/en-us.json'

const EnLang = {
  messages: {
    ...enMessages,
  },
  antd: antdEn,
  locale: 'en-US',
}
export default EnLang
